




















































































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import {
    ActionError as campaignStoreErr,
    CurrentCampaignType,
    CurrentAdsetType,
} from '@/store/campaign/types';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetAd as feedbackTerms } from '@/const/terms/feedback/ad';
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';
import { SetCampaign as campaignFeedback} from '@/const/terms/feedback/campaign';
import { SetAdset as adsetFeedback} from '@/const/terms/feedback/adset';

import { STATUS } from '@/const/status/index';
import { DATE_TYPE } from '@/const/types';
import { TableOptionType, DefaultOption } from '@/const/options/DefaultTableOption';
import {
    AdDataType,
    IAdData,
    AdResponse,
    IFilterForm,
} from './types';
import { AxiosError, AxiosResponse } from 'axios';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import ExplainColumn from '@/components/ElementComponent/Column/ExplainColumn.vue';
import ImageColumn from '@/components/ElementComponent/Column/ImageColumn.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';

import { Table as ElTable } from 'element-ui';

import { CampaignInfoResponse } from '../../editingTypes';
import { AdsetResponse, IAdsetSummary, IAdsetBrief } from '../types';

const campaignModule = namespace('Campaign');
@Component<Ad>({
    name: 'Ad',
    components: {
        Select,
        DateRangePicker,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
        ExplainColumn,
        ImageColumn,
        NumberInput,
    },
})
export default class Ad extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;
    
    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean = false;

    private filterForm: IFilterForm = {page: 1, totalPages: 0, sort: null};
    
    private tableData: AdDataType = [];
    private selectedAd: AdDataType = [];
    private dateValue: DATE_TYPE[] = [new Date(), new Date()]
    private imgVisible: boolean = false;
    private clickedImgID: string = '';
    private clickedImgSrc: string = '';

    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.State('currentAdset') private currentAdset!: CurrentAdsetType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset!: any;

    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }
    
    private refreshDate(v: Date[]) {
        if (v) {
            this.getAdResponseHandler();
        }
    }
    private resizeHandler(e: Event, row: IAdData, property: keyof IAdData) {
        const table = this.$refs.table as ElTable;
        table.doLayout();
    }

    private sortChangeHandler({column, prop, order}: {column: any, prop: string, order: string}) {
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getAdResponseHandler();
    }
    private handleSelectionChange(val: AdDataType) {
        this.selectedAd = val;
    }
    private showImg(e: Event, row: IAdData, property: keyof IAdData) {
        this.clickedImgSrc = row[property] as string;
        this.clickedImgID = '[ '+ terms.ad.default +' ID ] ' + String(row.creative_id);
        this.imgVisible = true;
    }
    private hideImg() {
        this.imgVisible = false;
        this.clickedImgID = '';
        this.clickedImgSrc = '';
    }

    private deleteAds() {
        this.deleteConfirmVisible = false;
        const targets = this.selectedAd.map((item: IAdData) => {
            return {
                adset_id: item.adset_id,
                id: item.creative_id,
            }
        })
        if (targets.length === 0) return true;
        this.loading = true;

        this.$http.adserverAPI.post('DeleteAdsetCreativeMatch', {
            creatives: targets,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteAd.success);
                    this.getAdResponseHandler();
                    return;
                }
                throw new Error(feedbackTerms.deleteAd.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteAd.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false;
                throw err;
            })
    }
    private changeStatus(ads: IAdData[], is_use: boolean | null = null, fromTools: boolean = false ) {
        if (ads.length === 0) return false;
        const ad_ids = ads.map((item: IAdData) => item.creative_id);
        const ad_reqs = ads.map((item: IAdData) => ({
            adset_id: item.adset_id,
            id: item.creative_id
        }));
        let toStatus: boolean = ((ads[0].status as STATUS) & 1) === (fromTools ?  STATUS.ACTIVE : STATUS.INACTIVE);
        if (is_use !== null ) toStatus = is_use;
        let statusBackup: STATUS[] = [];

        ads.forEach((item: IAdData) => {
            const s = item.status as STATUS;
            if (fromTools) statusBackup.push(s);
            else statusBackup.push(((s & ~1) | ((s & 1) ^ 1)));
            item.status = (s & ~1) | (toStatus? STATUS.ACTIVE : STATUS.INACTIVE);
            this.$nextTick(() => {
                item.disabled = true;
            });
        })
        statusBackup = statusBackup.reverse();
        this.$http.adserverAPI.post('UpdateAdsetCreativeStatus', {
            creatives: ad_reqs,
            is_use: toStatus,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.changeStatus.success);
                    return true;                
                }
                throw new Error(feedbackTerms.changeStatus.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.changeStatus.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                
                ads.forEach((item: IAdData) => {
                    const s = statusBackup.pop() as STATUS;
                    item.status = s;
                })
                throw err;
            })
            .finally(() => {
                this.loading = false;
                ads.forEach((item: IAdData) => {
                    item.disabled = false;
                })
            })
    }
    private saveWeight() {
        this.submit().then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.saveWeight.success); 
                    return;
                }
                throw new Error(feedbackTerms.saveWeight.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.saveWeight.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
    }
    private submit() {
        const reqData = this.tableData.map((item: IAdData) => ({
                adset_id: item.adset_id,
                id: item.creative_id,
                weight: item.weight ? item.weight : 0,
            })
        );
        return this.$http.adserverAPI.post('UpdateAdsetCreativeWeight', {
            creatives: reqData,
        });
    }
    // private submit() {
    //     return Promise.resolve(JSON.parse(JSON.stringify({status: 200, data: {result: true}})));
    // }
    private getAdResponseHandler() {
        this.loading = true;
        this.getAdResponse().then((res: any) => res.data)
            .then((data: AdResponse) => {
                this.tableData = data.creatives.map( (item: IAdData) => {
                    const under: number = item.impression === 0 ? 1 : item.impression;
                    const ctr: number = item.click / under * 100;
                    return {
                        ...item,
                        ctr,
                    } as IAdData;
                });
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }
    
    private getAdResponse() {
        this.setRouteQueryFromFilter();
        const sort = this.filterForm.sort && this.filterForm.sort.prop ? `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetCreativeReport', {
            campaign_id: this.currentCampaign.id,
            adset_id: this.currentAdset.idList,
            since: this.date[0],
            until: this.date[1],
            page_no: this.filterForm.page,
            sort: sort,
        })
    }
    
    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {
            since: (this.dateValue[0] as Date).getTime(),
            until: (this.dateValue[1] as Date).getTime(),
        }
        this.filterForm.page && (query.page = this.filterForm.page);
        this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order && (query.sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        query.since !== undefined && (this.dateValue[0] = new Date(Number.parseInt(query.since as string)));
        query.until !== undefined && (this.dateValue[1] = new Date(Number.parseInt(query.until as string)));
        this.dateValue = [this.dateValue[0], this.dateValue[1]];
        
        query.page !== undefined && (this.filterForm.page = Number.parseInt((query.page as string)));
        query.sort !== undefined && (this.filterForm.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private async created() {
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            const campaignID = this.$route.params.campaignID;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.getResponse.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(campaignFeedback.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
        }

        if (this.$route.params.adsetGroup !== this.currentAdset.name) {
            const groupName = this.$route.params.adsetGroup;
            await this.$http.adserverAPI.post('GetAdsetReport', {
                campaign_id: this.currentCampaign.id,
                placements: ['1','2','3','4','5','6'],
                since: moment(Date.now()).format('YYYYMMDDHH'),
                until: moment(Date.now()).format('YYYYMMDDHH'),
                page_no: 0,
            }).then((res: any) => res.data)
                .then( async (data: AdsetResponse) => {
                    const target = data.adsets.find((adset: IAdsetSummary) => adset.name === groupName)
                    if (target) {
                        try {         
                            await this.setCurrentAdset({
                                idList: target.targets.map((inv: IAdsetBrief) => inv.adset_id),
                                name: target.name
                            })
                        } catch (err) {
                            switch (err.type) {
                                case campaignStoreErr.SET_CURRENT_ADSET:
                                    this.$notify.error(adsetFeedback.currentAdset.error.fail);
                                    break;
                            }
                            throw err;
                        }
                    } else {
                        throw new Error(adsetFeedback.getResponse.error.notFound);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(adsetFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'adset', params: {campaignID: this.currentCampaign.id.toString()}});
                    }
                    throw err;
                })
        }
        this.setRouteQueryToFilter();
        this.getAdResponseHandler();
    }
}

